<div [class]="labelStyle">
  <span class="space-subtitle">
    <h3 role="heading" [attr.aria-level]="ariaLevel" [attr.aria-label]="labelTitle">{{labelTitle}}</h3>
    <a role="button" *ngIf="linkSubtitle" [attr.id]="idLink" class="text-link-subtitle"
    [attr.aria-label]="linkSubtitleAriaLabel ? linkSubtitleAriaLabel : linkSubtitle" (click)="edit($event, labelTitle)">
      <span aria-hidden="true">{{linkSubtitle}}</span>
    </a>
  </span>

  <div aria-hidden="true" *ngIf="linkSubtitle" class="label-margin"></div>
  <app-alert-message *ngIf="textEditFalse && !linkSubtitle" class="center-block mrg-block-alert" [text]="textEditFalse"></app-alert-message>
  <div *ngFor="let item of itens">
    <div class="body" *ngIf="item.description" [attr.aria-label]="item.field + ' ' +  item.description" role="text">
      <p aria-hidden="true">{{item.field}}</p>
      <span aria-hidden="true">{{item.description}}</span>
    </div>
  </div> 
</div>
